/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnumDictionary, getRouteInitData, State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { map$, switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  isJeCcFiltered,
  isJeComponentCostCenter,
  JeCcFilter,
  JeCostCenter,
} from '../../../resources/job-estimate-details.model';
import { JeCommandService } from '../je-command.service';
import {
  JeDetailsState,
  queryJeCcFilter,
  queryJeCostCenters,
  queryJeEditable,
  queryJeSelectedCostCenterId,
} from '../je-details.state';
import { JeDetailsCcGridDefinition } from './je-details-cc-grid-definition.service';

@Component({
  selector: 'gh-je-details-cc-list',
  template: require('./je-details-cc-list.component.html'),
  styles: [require('./je-details-cc-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [JeDetailsCcGridDefinition],
})
export class JeDetailsCcListComponent implements OnInit {
  editable$: Observable<boolean>;
  costCenters$: Observable<JeCostCenter[]>;
  selectedCostCenterId$: Observable<Maybe<ID>>;
  ccFilter$: Observable<JeCcFilter>;

  ccFilterDict: EnumDictionary<JeCcFilter>;

  constructor(private route: ActivatedRoute,
              public gridDefinition: JeDetailsCcGridDefinition,
              private state: State<JeDetailsState>,
              private commands: JeCommandService) {

  }

  ngOnInit(): void {
    const { ccFilterDict } = getRouteInitData(this.route);

    this.ccFilter$ = this.state.select(queryJeCcFilter);
    this.costCenters$ = this.ccFilter$.pipe(switchMap$((filter) => this.state.select(queryJeCostCenters).pipe(
      map$((costCenters) => costCenters.filter((cc) => isJeCcFiltered(cc, filter))))));
    this.selectedCostCenterId$ = this.state.select(queryJeSelectedCostCenterId);
    this.editable$ = this.state.select(queryJeEditable);

    this.ccFilterDict = ccFilterDict;
  }

  onAdd(): void {
    this.commands.costCenterAdd();
  }

  onViewOrderDetails(costCenter: JeCostCenter): void {
    this.commands.costCenterViewOrderDetails(costCenter);
  }

  isTypicalCc(costCenter: JeCostCenter): boolean {
    return !isJeComponentCostCenter(costCenter);
  }

  onSelectedCostCenterChanged(id?: ID): void {
    this.commands.costCenterSelect(id);
  }

  onChangeCcFilter(filter: JeCcFilter): void {
    this.commands.setCostCenterFilter(filter);
  }
}
